import { Entity, Var } from "addeus-common-library/stores/firestore";
import { Collection } from "addeus-common-library/stores/firestore/collection";
import moment from "moment-with-locales-es6";

export enum SocialProfileNetwork {
    facebook = "facebook",
    instagram = "instagram",
    linkedin = "linkedin",
    google = "google",
    linkedinPerson = "linkedin-person",
}

export const NETWORK_LABELS: Record<string, string> = {
    instagram: "Instagram",
    facebook: "Facebook",
    linkedin: "LinkedIn",
    google: "Google My Business",
    "linkedin-person": "LinkedIn",
};

export const ORDER_SOCIAL_NETWORK: string[] = [
    SocialProfileNetwork.instagram,
    SocialProfileNetwork.facebook,
    SocialProfileNetwork.linkedin,
    SocialProfileNetwork.linkedinPerson,
    SocialProfileNetwork.google,
];

@Collection({
    namespace: "SocialProfile",
})
export class SocialProfile extends Entity {
    @Var(String)
    name: string = "";

    @Var(SocialProfileNetwork)
    network: SocialProfileNetwork = SocialProfileNetwork.facebook;

    @Var(String)
    socialAccountID: string = "";

    @Var(String)
    picture?: string;

    @Var(String)
    uid: string = "";

    @Var(Boolean)
    active: boolean = false;

    @Var(String)
    error?: string;

    @Var(String)
    bio?: string;

    @Var(moment)
    updatedAt?: moment;

    @Var(Array.of(String))
    permissions: string[] = [];

    @Var(String)
    connectionError?: string;

    @Var(String)
    url?: string;
}
